import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetActiveVoucherRequest, GetActiveVoucherResponse } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'service-voucher.component.html',
  styleUrls: ['./service-voucher.component.scss']
})
export class ServiceVoucherComponent implements OnInit {
  vouchersResponse: GetActiveVoucherResponse | null = null;
  loading: boolean = true;

  constructor(
    private courierService: CourierService,
    public activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.refreshActiveVoucher();
  }

  async refreshActiveVoucher() {
    const serviceVoucherId = this.activeUserLocalDataService.activeServiceVoucherId;

    if (serviceVoucherId === undefined) {
      console.error('Service Voucher ID is undefined');
      this.activeUserLocalDataService.activeServiceVoucher = null;
      this.loading = false;
      return;
    }

    const request: GetActiveVoucherRequest = { serviceVoucherId };
    try {
      const response = await this.courierService.getActiveVouchers(request).toPromise();
      this.vouchersResponse = response ?? null;

      if (response && response.voucher) {
        this.activeUserLocalDataService.activeServiceVoucher = response.voucher;
      } else {
        this.activeUserLocalDataService.activeServiceVoucher = null;
      }
    } catch (error) {
      console.error('Error fetching active voucher:', error);
      this.activeUserLocalDataService.activeServiceVoucher = null;
    } finally {
      this.loading = false;
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}